module.exports = "<score-list (backScoreMode)=\"openMode($event)\"  *ngIf=\"scoreMode == 'list'\"></score-list>\n<score-detail *ngIf=\"scoreMode == 'detail'\" (backScoreMode)=\"openMode($event)\" [score_id]=\"choice_score_id\"></score-detail>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/score/score.template.html
// module id = ./src/app/pages/admin/icontact/score/score.template.html
// module chunks = main